import React from 'react';
import { siteConfig } from '../siteConfig';
import Marquee from '../components/Marquee';
import Hero from '../sections/Hero';
import Services from '../sections/Services';
import Industries from '../sections/Industries';
import About from '../sections/About';
import Contact from '../sections/Contact';

const Home: React.FC = () => (
  <main>
    <Hero variant={siteConfig.heroVariant} />
    <Marquee />
    <Services />
    <Industries />
    <About />
    <Contact />
  </main>
);

export default Home;
